/**
 * 排序交互模式枚举。
 */
export enum SortInteractionMode {
  /**
   * 直接排序模式：点击排序控件直接触发排序。
   */
  DirectMode = 1,

  /**
   * 选项排序模式：点击排序控件后，排序控件附近弹出浮窗，再在浮窗内选择某个Option才触发排序。
   */
  OptionsMode = 2,
}
